import { FileCheck2, Kanban } from 'lucide-react'
import Card from '../../../../components/common/Card'
import DefaultTabs from '../../../../components/common/Tabs'
import Business from './Pipelines'

export function ProductTabs() {
    const tabsData = [
        {
            icon: <Kanban className='w-4 h-4' />,
            label: (
                <div className='flex items-start justify-center gap-1'>
                    <p>Negócios</p>
                    <p className='text-xs text-brand-400 font-bold'>3</p>
                </div>
            ),
            value: 'tab1',
            content: <Business />
        },
        {
            icon: <FileCheck2 className='w-4 h-4' />,
            label: (
                <div className='flex items-start justify-center gap-1'>
                    <p>Documentos</p>
                    <p className='text-xs text-brand-400 font-bold'>2</p>
                </div>
            ),
            value: 'tab2',
            content: (
                <Card>
                    <p>Documentos</p>
                </Card>
            )
        }
    ]

    return <DefaultTabs tabs={tabsData} defaultValue='tab1' />
}
